import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import onboardingActions from '@mm/state/modules/onboardingState/actions';
import {
  activeChatbotSelector,
  selectActiveCompanyId,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { findIndex } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import useReactRouter from 'use-react-router';
import { CHATBOT_EDITOR } from '../../../common/constants/routes';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { ONBOARDING_ROUTES } from './constants';

export const useSetNextOnboardingStep = () => {
  const { history } = useReactRouter();
  const dispatch = useDispatch();
  const session = useSelector((state: StoreState) => state.session.session);
  const companyId = useSelector((state: StoreState) =>
    selectActiveCompanyId(state),
  );
  const chatbotId = useSelector(
    (state: StoreState) => state.chatbot.basicListByCompany[0]?.id,
  );
  const modalActions = useModalActions();

  const chatbot = useSelector(activeChatbotSelector);

  const setNextOnboardingStep = async (
    nextOnboardingStep: OnboardingSignupStep,
    skipRedirect = false,
    audienceExtractorChannel?: 'instagram' | 'facebook',
  ) => {
    const userSignupStepSet =
      session &&
      session.userAttributes &&
      session.userAttributes.onboardingSignupStep;
    const highestSignupStepCompleted = userSignupStepSet
      ? session.userAttributes.onboardingSignupStep
      : '';
    const highestSignupStepCompletedIndex = findIndex(
      ONBOARDING_ROUTES,
      route => route.id === highestSignupStepCompleted,
    );
    const nextOnboardingStepIndex = findIndex(
      ONBOARDING_ROUTES,
      route => route.id === nextOnboardingStep,
    );

    if (userSignupStepSet === OnboardingSignupStep.NONE) {
      console.log('wrong action');
    }
    if (nextOnboardingStep === OnboardingSignupStep.NONE) {
      dispatch(onboardingActions.setJustCompletedOnboarding(true));
      await dispatch(
        usersCRUDActions.updateUserAttributes(companyId, session.id, {
          onboardingSignupStep: nextOnboardingStep,
        }),
      );

      if (!skipRedirect) {
        if (chatbotId || chatbot?.id) {
          history.push(
            BotBuilderRoutes.automationHome.getLink({
              chatbotId: chatbotId || chatbot.id,
            }),
          );
          if (audienceExtractorChannel) {
            dispatch(
              onboardingActions.setAudienceExtractorChannel(
                audienceExtractorChannel,
              ),
            );
            modalActions.openAudienceExtractorModal({
              channel: audienceExtractorChannel,
            });
          }
        } else {
          history.push(CHATBOT_EDITOR);
        }
      }
    } else {
      // Only set if it's a step higher
      if (nextOnboardingStepIndex > highestSignupStepCompletedIndex) {
        await dispatch(
          usersCRUDActions.updateUserAttributes(companyId, session.id, {
            onboardingSignupStep: nextOnboardingStep,
          }),
        );
      }

      if (!skipRedirect) {
        const onboardingStep = ONBOARDING_ROUTES.find(
          ({ id }) => id === nextOnboardingStep,
        );
        const chosenNextStep = onboardingStep
          ? onboardingStep
          : ONBOARDING_ROUTES[1];
        history.push(chosenNextStep.path);
      }
    }
  };

  return { setNextOnboardingStep };
};
